import React, { PureComponent } from 'react';
import { ShowModifier } from './Accordion';
import ModifiersByServing from './ModifiersByServing';
import Serving from '../../dashboard/components/items/components/PizzaCreatorModifiers/classes/Serving';
import { groupBy } from '../../../lib/helper';

const WHOLE = 'WHOLE';
const LEFT_SIDE = 'LEFT SIDE';
const RIGHT_SIDE = 'RIGHT SIDE';

class PizzaCreatorOrderModifiers extends PureComponent {
  
  render() {
    const { modifiers } = this.props;

    const simpleModifiers = modifiers.filter(modifier => modifier.use_builder === false);
    const builderModifiers = modifiers.filter(modifier => modifier.use_builder === true);
    const groupedBuilderModifiers = groupBy(builderModifiers,'selected_serving.id');
    const wholeModifiers = groupedBuilderModifiers[Serving.WHOLE];
    const leftModifiers = groupedBuilderModifiers[Serving.LEFT];
    const rightModifiers = groupedBuilderModifiers[Serving.RIGHT];
    return (
      <div>
        {simpleModifiers.map( (modifier, key) => (
          <ShowModifier
                    key={key}
                    strike={false}
                    ingredient={
                      {
                        title: modifier.title,
                        cost: modifier.cost,
                        availability: modifier.availability,
                      }
                    }
          />
        ))}
        {wholeModifiers ? <ModifiersByServing servingTitle={WHOLE} servingModifiers={wholeModifiers} /> : null}
        {leftModifiers ? <ModifiersByServing servingTitle={LEFT_SIDE} servingModifiers={leftModifiers} /> : null}
        {rightModifiers ? <ModifiersByServing servingTitle={RIGHT_SIDE} servingModifiers={rightModifiers} /> : null}
      </div>
    );
  }
}

export default PizzaCreatorOrderModifiers;



// WEBPACK FOOTER //
// ./src/views/common/OrderPanel/PizzaCreatorOrderModifiers.jsx